import HowToMakeAPencilEmbeddedComponent from "../lessonPlanCanvaComponents/howToMakePencil";
import { LessonId } from "../enums/lessonId";
const neonSigns = require("../lessonPlanPdfs/4th-grade-neon-signs-paint-stix.pdf");
const colorSplash = require("../lessonPlanPdfs/Color Splash.pdf");
const goache = require("../lessonPlanPdfs/goache.pdf");
const goacheWrapUp = require("../lessonPlanPdfs/GouacheWrapUp.pdf");
const henna = require("../lessonPlanPdfs/henna.pdf");
const scratchboard = require("../lessonPlanPdfs/scratchboard.pdf");
const smores = require("../lessonPlanPdfs/smores.pdf");
const pastelPortrait = require("../lessonPlanPdfs/pastelPortrait.pdf");
const vinyl = require("../lessonPlanPdfs/VinylLesson.pdf");
const vinylSteps = require("../lessonPlanPdfs/VinylSteps.pdf");
const poptarts = require("../lessonPlanPdfs/poptarts.pdf");
const poptartsPlanning = require("../lessonPlanPdfs/poptartsPlanning.pdf");
const howToMakeAGif = require("../lessonPlanPdfs/howToMakeAGif.pdf");
const howToMakeAGifLesson = require("../lessonPlanPdfs/howToMakeAGifLesson.pdf");

export interface ILesson {
    file?: File;
    title: string;  
    canvaEmbedComponent?: JSX.Element;
}

const map = {
    [LessonId.neonsigns]: [{ file: neonSigns, title: 'Neon Signs' }],
    [LessonId.colorsplash]: [{ file: colorSplash, title: 'Color Splash' }],
    [LessonId.goache]: [{ file: goache, title: 'Goache' }, { file: goacheWrapUp, title: "Recipe Wrap Up" }],
    [LessonId.henna]: [{ file: henna, title: 'Henna' }],
    [LessonId.scratchboard]: [{ file: scratchboard, title: 'Scratchboard' }],
    [LessonId.smores]: [{ file: smores, title: 'Smore\'s' }],
    [LessonId.pastelPortrait]: [{ file: pastelPortrait, title: 'Pastel Portrait' }],
    [LessonId.vinyl]: [{ file: vinyl, title: 'Vinyl Lesson' }, { file: vinylSteps, title: 'Vinyl Steps'}],
    [LessonId.poptarts]: [{ file: poptarts, title: 'PopTarts' }, { file: poptartsPlanning, title: 'Lesson Plan' }],
    [LessonId.howtomakeagif]: [{ file: howToMakeAGif, title: 'Photopea Instructions' }, { file: howToMakeAGifLesson, title: 'Lesson Plan'}],
    [LessonId.whatisapencilmadeof]: [{ file: undefined, title: 'What is a pencil made of?', canvaEmbedComponent: HowToMakeAPencilEmbeddedComponent }],
};

export const GetLessonDataForLessonId = (lessonId: LessonId): Array<ILesson> => {
    return (map as any)[lessonId];  
}